/** HEAD 조회 BE 요청 상한 — GetInboundsRequest @Max(1000). 신규 일반조회 10000 으로 완화하지 않는다. 전량 조회는 이 크기로 구간을 나눠 받는다(LOGISPRD-15268). */
export const INBOUNDS_FETCH_SIZE = 1000
